import { render } from "./InfoFacturesLocataires.vue?vue&type=template&id=0a355db0&scoped=true"
import script from "./InfoFacturesLocataires.vue?vue&type=script&lang=js"
export * from "./InfoFacturesLocataires.vue?vue&type=script&lang=js"

import "./InfoFacturesLocataires.vue?vue&type=style&index=0&id=0a355db0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a355db0"]])

export default __exports__